export class DomUtil {
  /**
   * 是否是一个可编辑的元素，也就是可以被 focus 的 element
   * @param element
   */
  static isEditElement(element: any) {
    if (!element) {
      return false;
    }

    const tags = ["INPUT", "TEXTAREA", "SELECT"];
    if (tags.includes(element.tagName) && !element.disabled) {
      return true;
    }

    return element.contenteditable === "true";
  }

  static hasTheme(element: any, themeType: string) {
    let currentElement = element.parentElement;

    while (currentElement) {
      const dataThemeValue = currentElement.getAttribute("data-theme");
      if (dataThemeValue === themeType) {
        return true;
      }
      currentElement = currentElement.parentElement;
    }

    return false;
  }

  static hasAttr(element: any, attr: string, value: string) {
    let currentElement = element;

    while (currentElement) {
      const dataValue = currentElement.getAttribute(attr);
      if (dataValue === value) {
        return true;
      }
      currentElement = currentElement.parentElement;
    }

    return false;
  }

  /**
   * 判断元素是否滚到到了最底部
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight
   * @param target
   * @returns
   */
  static hasScrollToBottom<T extends HTMLElement>(target: T): boolean {
    const contentScrollTop = target.scrollTop; // 滚动条距离顶部
    const clientHeight = target.clientHeight; // 可视区域
    const scrollHeight = target.scrollHeight; // 滚动条内容的总高度
    // scrolltop 是一个不精准的小数
    // FIXME: -1 为了保证准确
    return Math.round(contentScrollTop + clientHeight) >= scrollHeight - 1;
  }
}
